module.exports = __webpack_public_path__ + "static/media/post-1.daa40579.pdf";